// extracted by mini-css-extract-plugin
module.exports = {"container":"NewsCards_container__XDmrn","header":"NewsCards_header__3lWty","link":"NewsCards_link__0iNm7","cards":"NewsCards_cards__aqsfS"};